import React, { useState } from 'react';
import axios from 'axios';
import { Alert, Button, Container, Form } from 'react-bootstrap';
import PageHeading from './PageHeading';

const TIKTOK_URL = 'https://www.tiktok.com/@naturesnefer';

const TikTokIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="currentColor"
      d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.27 6.27 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.77 1.52V6.76a4.85 4.85 0 0 1-1-.07Z"
    />
  </svg>
);

const SOCIALS = [
  {
    name: 'TikTok',
    handle: '@naturesnefer',
    href: TIKTOK_URL,
    Icon: TikTokIcon,
  },
];

function ContactPage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [fax, setFax] = useState('');
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSending(true);
    try {
      await axios.post('/api/contact', { name, email, message, fax });
      setSent(true);
      setName('');
      setEmail('');
      setMessage('');
      setFax('');
    } catch (err) {
      const apiError =
        err.response && err.response.data && err.response.data.error;
      setError(apiError || "We couldn't send your message. Please try again.");
    } finally {
      setSending(false);
    }
  };

  return (
    <Container className="Center-column contact-page">
      <div className="pg-break"> </div>
      <PageHeading icon="mail">Contact</PageHeading>
      <p className="contact-intro">
        Questions, ideas, or a note about your order — we read every message.
      </p>

      {sent && (
        <Alert variant="success" className="contact-alert">
          Thank you. Your message is on its way.
        </Alert>
      )}
      {error && (
        <Alert variant="danger" className="contact-alert">
          {error}
        </Alert>
      )}

      <Form className="contact-form" onSubmit={handleSubmit}>
        <Form.Group className="mb-3" controlId="contact-name">
          <Form.Label>Name</Form.Label>
          <Form.Control
            type="text"
            name="name"
            autoComplete="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            maxLength={80}
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="contact-email">
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="email"
            name="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            maxLength={120}
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="contact-message">
          <Form.Label>Message</Form.Label>
          <Form.Control
            as="textarea"
            rows={5}
            name="message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
            minLength={10}
            maxLength={2000}
          />
        </Form.Group>
        <Form.Group className="contact-hp" aria-hidden="true">
          <Form.Label>Fax</Form.Label>
          <Form.Control
            type="text"
            name="fax"
            tabIndex={-1}
            autoComplete="off"
            value={fax}
            onChange={(e) => setFax(e.target.value)}
          />
        </Form.Group>
        <Button variant="success" type="submit" disabled={sending}>
          {sending ? 'Sending…' : 'Send message'}
        </Button>
      </Form>

      <section className="contact-socials" aria-labelledby="connect-heading">
        <h2 id="connect-heading">Connect with us</h2>
        <ul className="contact-social-list">
          {SOCIALS.map((social) => (
            <li key={social.name}>
              <a
                className="contact-social-link"
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
              >
                <social.Icon />
                <span className="contact-social-copy">
                  <span className="contact-social-name">{social.name}</span>
                  <span className="contact-social-handle">{social.handle}</span>
                </span>
              </a>
            </li>
          ))}
        </ul>
      </section>
    </Container>
  );
}

export default ContactPage;
